import React from 'react';
import {useMenu} from '../../../hooks/useMenu';
import CommonMenu from '../../menu/commonMenu';
import styles from './sub-menu.module.css';

function SubMenu({content, ...props}) {
  const {selected, onComponent} = useMenu();
  const {menuList, caption} = styles;

  return (
    <>
      <div className={caption}>
        <span>{content}</span>
      </div>
      <div className={menuList}>
        <CommonMenu {...props} />
      </div>
    </>
  );
}

export default SubMenu;
